module.exports = __webpack_public_path__ + "img/album2.bde27315.jpg";